import React from "react";

// eslint-disable-next-line no-shadow
export enum Tab {
  BASIC = 1,
  THREE_D_SPACE = 2,
  VH_DEFINE = 3,
  MENU_SET = 4,
}

interface TabNavItemProps {
  tab: Tab;
  tabName: string;
  currentTab: Tab;
  setCurrentTab: React.Dispatch<React.SetStateAction<Tab>>;
}

export const TabNavItem = (props: TabNavItemProps) => {
  const { tab, tabName, currentTab, setCurrentTab } = props;

  return (
    <li>
      <button
        type="button"
        className={
          `inline-block p-4 font-semibold ${currentTab === tab ? "text-primary bg-sub": " text-sub"} focus:outline-none focus:ring-0`
        }
        onClick={() => setCurrentTab(tab)}
      >
        { tabName }
      </button>
    </li>
  );
}